import moment from "moment";
import { WAREHOUSE_BUILD_VERSIONS, warehouseId } from "../constants";

export const BuildVersion = WAREHOUSE_BUILD_VERSIONS[warehouseId];

export const PortalName = "TO Portal";

const siteConfig = {
  footerText: `©${moment().format("YYYY")} Created by Intellihealth Pvt. Ltd.
  Version ${BuildVersion}`,
};

export { siteConfig };
